
import Vue from 'vue';

import '@/pages/search/results/table/TableHeader.vue';
import { definitions, ColumnDefs, DisplaySettingsForRendering, Rows, ColumnDef, HitRowData, GroupRowData, DocRowData } from '@/pages/search/results/table/table-layout';
import { BLSearchParameters } from '@/types/blacklabtypes';


// ensure we have these components loaded
import '@/pages/search/results/table/DocRow.vue';
import '@/pages/search/results/table/DocRowDetails.vue';
import '@/pages/search/results/table/HitRow.vue';
import '@/pages/search/results/table/HitRowDetails.vue';
import '@/pages/search/results/table/GroupRow.vue';
import '@/pages/search/results/table/GroupRowDetails.vue';

export default Vue.component('GenericTable', {
	props: {
		cols: Object as () => ColumnDefs,
		header: Array as () => ColumnDef[],
		rows: Object as () => Rows,
		info: Object as () => DisplaySettingsForRendering,
		disabled: Boolean,
		disableDetails: Boolean,

		showTitles: { default: true },
		sort: String,

		/// UGH, required to get group contents as this is not exposed in the results directly.
		type: String as () => 'hits'|'docs',
		query: Object as () => BLSearchParameters,
	},
	data: () => ({
		definitions,
		openRows: {} as Record<number|string, boolean>,

		hoverMatchInfos: undefined as undefined|string[],
		hoverMatchInfosId: undefined as undefined|string,
	}),
	methods: {
		isOpenable(row: HitRowData|DocRowData|GroupRowData) {
			if (this.disabled || this.disableDetails) return false;
			if (row.type === 'group') return true;
			if (row.type === 'hit' && this.type === 'hits') return true;
			if (row.type === 'doc' && this.type === 'docs' && row.hits) return true;
			return false;
		},
		hasForeignHit(rows: Rows) {
			return rows.rows.some(row => row.type === 'hit' && row.isForeign);
		},
		toggleRow(index: number) {
			const row = this.rows.rows[index];
			if (!this.isOpenable(row)) return;
			const id = row.hit_id || index;
			const newState = !this.openRows[id];
			this.$set(this.openRows, id, newState);
		},
		openFullConcordances(row: HitRowData|DocRowData|GroupRowData) {
			if ('displayname' in row) {
				this.$emit('viewgroup', row.id, row.displayname);
			}
		}
	},
	watch: {
		query() { this.openRows = {}; }
	}
})
